module.exports = __webpack_public_path__ + "media/photos/term-bg-2-87f0aca1.jpg";